import React__default from 'react';
import { TooltipImage } from './tooltip-image.esm.js';

var ArticleToolTip = function ArticleToolTip(props) {
  var translatedFromText = props.translatedFromText,
    tooltipText = props.tooltipText;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-start gap-[9px] align-middle font-sans text-p-16 text-[#757575]"
  }, /*#__PURE__*/React__default.createElement("p", null, translatedFromText), /*#__PURE__*/React__default.createElement(TooltipImage, {
    tooltipText: tooltipText
  }));
};

export { ArticleToolTip };
//# sourceMappingURL=article-tooltip.esm.js.map
